<template>
    <div>
        <h1 class="display-heading">Invite New Clinic</h1>

        <form @submit.prevent="validateForm">
            <h5>Invitee Details</h5>

            <div class="form-group">
                <label>Invitee Clinic Name</label>
                <input type="text" name="inviteeName" data-vv-validate-on="blur" data-vv-as="invitee name" placeholder="Invitee Clinic Name"
                    v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('inviteeName')
                    }"
                    v-model="form.inviteeName">
                <div v-show="validationErrors.has('inviteeName')" class="invalid-feedback">
                    {{ validationErrors.first('inviteeName') }}
                </div>
            </div>

            <div class="form-group">
                <label>E-mail Address</label>
                <input type="text" name="emailAddress" data-vv-validate-on="blur" data-vv-as="e-mail address" placeholder="E-mail Address"
                    v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('emailAddress')
                    }"
                    v-model="form.emailAddress">
                <div>
                    <small>Please enter the e-mail address for this invitation to be delivered to.</small>
                </div>
                <div v-show="validationErrors.has('emailAddress')" class="invalid-feedback">
                    {{ validationErrors.first('emailAddress') }}
                </div>
            </div>

            <button type="button" @click="submitInviteRequest" class="btn btn-primary btn-primary-insv mr-2 mb-2">Create Invitation Request</button>
            <router-link :to="{'name': 'admin-invite-users'}" class="btn btn-secondary mb-2">Back to Previous Page</router-link>
        </form>

        <popup-modal ref="popupAddDone" title="Invite Users" :hasCloseButton="false" sizeClass="modal-lg">
            <template slot="content">
                <p>{{inviteResultText}}</p>

                <template v-if="inviteWithErrors">
                    <p>{{inviteResultErrorText}}</p>

                    <table class="table">
                        <colgroup>
                            <col width="50">
                            <col>
                            <col>
                            <col>
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email Address</th>
                                <th scope="col">Reason</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(invite, index) in inviteErrorList" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{invite.name ? invite.name : '-'}}</td>
                                <td>{{invite.email}}</td>
                                <td>{{invite.reason ? invite.reason : '-'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </template>
            <template slot="footer">
                <template v-if="inviteWithErrors">
                    <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="dismissPopupReEdit">
                        Edit Invitation
                    </button>
                </template>
                <template v-else>
                    <template v-if="!submitInviteHasError">
                        <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="viewInvitationReport">
                            View Invitation Report
                        </button>
                        <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissDoneConfirmation">Invite Another Clinic</button>
                    </template>
                    <template v-else>
                        <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="tryAgain">Try Again</button>

                        <button type="button" class="btn btn-secondary" @click="cancelTry">Cancel</button>
                    </template>
                </template>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
export default {
    'name': 'SuperAdminInviteNewDoctor',
    'components': {
        popupModal
    },
    data () {
        return {
            'form': {
                'inviteeName': '',
                'emailAddress': '',
                'specialtyId': ''
            },
            'specialties': [],

            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': '',

            'inviteWithErrors': false,
            'inviteResultText': '',
            'inviteResultErrorText': '',
            'inviteErrorList': [],

            'submitInviteHasError': false

        };
    },
    'methods': {
        submitInviteRequest () {
            this.$validator.validateAll().then((isValid) => {
                if (isValid) {
                    this.axios.post('/Invite/SuperAdminInviteNewClinic', {
                        'e': this.form.emailAddress,
                        'n': this.form.inviteeName
                    }).then(({
                        data
                    }) => {
                        this.submitInviteHasError = false;
                        let successList = data.data.si;
                        let failedList = data.data.fi;

                        this.inviteResultText = `${successList.length} invitation${successList.length > 1 ? 's' : ''} created.`;

                        if (failedList.length > 0) {
                            this.inviteWithErrors = true;
                            this.inviteResultErrorText = `${failedList.length} failed invitation${failedList.length > 1 ? 's' : ''}.`;
                            this.inviteErrorList = failedList.map((invitation) => ({
                                'email': invitation.e,
                                'name': invitation.n,
                                'reason': invitation.fr
                            }));
                        } else {
                            this.inviteWithErrors = false;
                            this.inviteResultErrorText = '';
                            this.inviteErrorList = [];
                        }

                        this.$refs.popupAddDone.show();
                    }).catch(() => {
                        this.submitInviteHasError = true;
                        this.inviteResultText = 'Error saving invitation. Please try again.';
                        this.$refs.popupAddDone.show();
                    });
                }
            });
        },
        dismissPopupReEdit () {
            this.$refs.popupAddDone.hide();
        },
        dismissDoneConfirmation () {
            this.$refs.popupAddDone.hide().then(() => {
                window.location.reload();
            });
        },
        tryAgain () {
            this.$refs.popupAddDone.hide().then(() => {
                this.confirmInvitation();
            });
        },
        cancelTry () {
            this.$refs.popupAddDone.hide();
        },
        viewInvitationReport () {
            this.$refs.popupAddDone.hide().then(() => {
                this.$router.push({
                    'name': 'admin-user-invitation-report',
                    'query': { 'invitationType': 5 }
                });
            });
        }
    }
};
</script>
